module.exports = __webpack_public_path__ + "img/news7-3.64f34973.png";